import { Search } from "./search";
import { SearchSuggest } from "./searchsuggest";
import { Site } from "./site";
import { Web } from "./webs";
import { UserProfileQuery } from "./userprofiles";
import { NavigationService } from "./navigation";
import { SocialQuery } from "./social";
import { SiteScripts } from "./sitescripts";
import { SiteDesigns } from "./sitedesigns";
import { UtilityMethod } from "./utilities";
import { setup as _setup, } from "./config/splibconfig";
import { HubSites } from "./hubsites";
/**
 * Root of the SharePoint REST module
 */
var SPRest = /** @class */ (function () {
    /**
     * Creates a new instance of the SPRest class
     *
     * @param options Additional options
     * @param baseUrl A string that should form the base part of the url
     */
    function SPRest(_options, _baseUrl) {
        if (_options === void 0) { _options = {}; }
        if (_baseUrl === void 0) { _baseUrl = ""; }
        this._options = _options;
        this._baseUrl = _baseUrl;
    }
    /**
     * Configures instance with additional options and baseUrl.
     * Provided configuration used by other objects in a chain
     *
     * @param options Additional options
     * @param baseUrl A string that should form the base part of the url
     */
    SPRest.prototype.configure = function (options, baseUrl) {
        if (baseUrl === void 0) { baseUrl = ""; }
        return new SPRest(options, baseUrl);
    };
    /**
     * Global SharePoint configuration options
     *
     * @param config The SharePoint configuration to apply
     */
    SPRest.prototype.setup = function (config) {
        _setup(config);
    };
    /**
     * Executes a search against this web context
     *
     * @param query The SearchQuery definition
     */
    SPRest.prototype.searchSuggest = function (query) {
        var finalQuery;
        if (typeof query === "string") {
            finalQuery = { querytext: query };
        }
        else {
            finalQuery = query;
        }
        return this.create(SearchSuggest).execute(finalQuery);
    };
    /**
     * Executes a search against this web context
     *
     * @param query The SearchQuery definition
     */
    SPRest.prototype.search = function (query) {
        return this.create(Search).execute(query);
    };
    /**
     * Executes the provided search query, caching the results
     *
     * @param query The SearchQuery definition
     * @param options The set of caching options used to store the results
     */
    SPRest.prototype.searchWithCaching = function (query, options) {
        return this.create(Search).usingCaching(options).execute(query);
    };
    Object.defineProperty(SPRest.prototype, "site", {
        /**
         * Begins a site collection scoped REST request
         *
         */
        get: function () {
            return this.create(Site);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "web", {
        /**
         * Begins a web scoped REST request
         *
         */
        get: function () {
            return this.create(Web);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "profiles", {
        /**
         * Access to user profile methods
         *
         */
        get: function () {
            return this.create(UserProfileQuery);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "social", {
        /**
         * Access to social methods
         */
        get: function () {
            return this.create(SocialQuery);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "navigation", {
        /**
         * Access to the site collection level navigation service
         */
        get: function () {
            return this.create(NavigationService);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new batch object for use with the SharePointQueryable.addToBatch method
     *
     */
    SPRest.prototype.createBatch = function () {
        return this.web.createBatch();
    };
    Object.defineProperty(SPRest.prototype, "utility", {
        /**
         * Static utilities methods from SP.Utilities.Utility
         */
        get: function () {
            return this.create(UtilityMethod, "");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "siteScripts", {
        /**
         * Access to sitescripts methods
         */
        get: function () {
            return this.create(SiteScripts, "");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "siteDesigns", {
        /**
         * Access to sitedesigns methods
         */
        get: function () {
            return this.create(SiteDesigns, "");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPRest.prototype, "hubSites", {
        /**
         * Access to Hub Site methods
         */
        get: function () {
            return this.create(HubSites);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the Web instance representing the tenant app catalog web
     */
    SPRest.prototype.getTenantAppCatalogWeb = function () {
        var _this = this;
        return this.create(Web, "_api/SP_TenantSettings_Current").get().then(function (r) {
            return (new Web(r.CorporateCatalogUrl)).configure(_this._options);
        });
    };
    /**
     * Handles creating and configuring the objects returned from this class
     *
     * @param fm The factory method used to create the instance
     * @param path Optional additional path information to pass to the factory method
     */
    SPRest.prototype.create = function (fm, path) {
        return new fm(this._baseUrl, path).configure(this._options);
    };
    return SPRest;
}());
export { SPRest };
export var sp = new SPRest();
//# sourceMappingURL=rest.js.map